import Graph from "./graph";
import version from "./version";

// Includes only the "core" of graphlib
export default {
  Graph,
  version
};
